import { Controller } from "@hotwired/stimulus"

// Copies data-clipboard-text-value to the clipboard and briefly flashes
// the trigger's label so the operator gets feedback without a toast
// system. Used by the Deployment card's alias copy button.
export default class extends Controller {
  static values = { text: String }

  async copy() {
    const original = this.element.textContent
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.element.textContent = "Copied!"
    } catch {
      // Permission denied / non-secure context — keep the rejection out
      // of the console and don't pretend the copy worked.
      this.element.textContent = "Copy failed"
    }
    setTimeout(() => { this.element.textContent = original }, 1200)
  }
}
